import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Switch as MuiSwitch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import colors from '../../foundations/colors.module.scss';
import { Checkmark, Minus } from '../../icons';
import { ConditionalWrapper } from '../ConditionalWrapper';
import { useIntentBehavior } from '../IntentBehavior';
import { Tooltip } from '../Tooltip';
const useStyles = makeStyles({
    root: {
        width: 48,
        height: 24,
        padding: 0
    },
    switchBase: {
        padding: 1,
        color: colors.white,
        '&$checked': {
            color: colors.white,
            transform: 'translateX(24px)',
            '& + $track': {
                backgroundColor: colors.buttonPrimary,
                opacity: 1,
                border: 'none'
            },
            '&:hover + $track': {
                backgroundColor: colors.buttonPrimaryDark
            },
            '& $customThumb': {
                color: colors.buttonPrimary
            },
            '&$disabled $customThumb': {
                color: colors.dark300
            },
            '&$disabled + $track': {
                backgroundColor: colors.dark300
            }
        },
        '&$disabled $customThumb': {
            color: colors.dark300
        },
        '&:hover + $track': {
            backgroundColor: colors.buttonDisabledDark
        },
        '&:hover $customThumb': {
            color: colors.buttonDisabledDark
        }
    },
    checked: {},
    disabled: {},
    track: {
        borderRadius: 90,
        backgroundColor: colors.buttonDisabled,
        opacity: 1
    },
    customThumb: {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: colors.white,
        color: colors.buttonDisabled,
        borderRadius: '50%'
    },
    wrapper: {
        display: 'inline-flex'
    }
});
export function Switch(props) {
    const { className, tooltip, intent, disabled, testId, checked } = props, rest = _object_without_properties(props, [
        "className",
        "tooltip",
        "intent",
        "disabled",
        "testId",
        "checked"
    ]);
    const styles = useStyles();
    const { customThumb, wrapper } = styles, restStyles = _object_without_properties(styles, [
        "customThumb",
        "wrapper"
    ]);
    const { getDisabled, getTooltip } = useIntentBehavior();
    const disabledFromIntent = intent ? getDisabled(intent) : false;
    const tooltipFromIntent = intent ? getTooltip(intent) : null;
    const hasTooltip = !!(tooltip === null || tooltip === void 0 ? void 0 : tooltip.title) || !!tooltipFromIntent;
    return /*#__PURE__*/ _jsx(ConditionalWrapper, {
        condition: hasTooltip,
        wrapper: (children)=>/*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({}, tooltip || {
                placement: 'top',
                title: tooltipFromIntent
            }), {
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn(wrapper, className),
                    "data-testid": testId && "".concat(testId, "-wrapper"),
                    children: children
                })
            })),
        children: /*#__PURE__*/ _jsx(MuiSwitch, _object_spread_props(_object_spread({}, rest), {
            checked: checked,
            "aria-checked": checked,
            disabled: disabledFromIntent || disabled,
            "data-testid": testId,
            className: cn(!hasTooltip && className),
            classes: restStyles,
            disableRipple: true,
            icon: /*#__PURE__*/ _jsx("div", {
                className: customThumb,
                children: /*#__PURE__*/ _jsx(Minus, {
                    size: 16
                })
            }),
            checkedIcon: /*#__PURE__*/ _jsx("div", {
                className: customThumb,
                children: /*#__PURE__*/ _jsx(Checkmark, {
                    size: 16
                })
            }),
            inputProps: _object_spread({
                'data-testid': testId && "".concat(testId, "-input")
            }, rest.inputProps)
        }))
    });
}
